import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {ToastType} from "../../app/enums/ToastType";
import {ToastsService} from "../../app/services/toasts.service";
import { NgClass } from '@angular/common';
import {HlmButtonImports} from '@spartan-ng/helm/button';


@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, HlmButtonImports]
})
export class ToastsComponent {
  toastService = inject(ToastsService);


  tTypes: typeof ToastType = ToastType;


  removeToast(id: number) {
    this.toastService.removeToast(id);
  }
}
